// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__BU6J_","description":"styles_description__1Cqf0"};